import React, {
  useContext,
  useDeferredValue,
  useMemo,
  useState,
  useRef
} from "react";
import { ProductContext } from "../context/ProductContext";
import { useNavigate } from "react-router-dom";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import noImage from "../assets/no-image.png";


import {
  FaPlus,
  FaSearch,
  FaEdit,
  FaEye,
  FaBoxes,
  FaTrash,
} from "react-icons/fa";

import "../styles/Products.css";

function Products() {


  const [showStockModal, setShowStockModal] = useState(false);
const [selectedProduct, setSelectedProduct] = useState(null);
const [newStockQty, setNewStockQty] = useState("");

const [searchTerm, setSearchTerm] = useState("");
const deferredSearchTerm = useDeferredValue(searchTerm);
const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage, setItemsPerPage] = useState(10);

const [selectedProducts, setSelectedProducts] = useState([]);
const [bulkAction, setBulkAction] = useState("");

  const fileInputRef =
  useRef(null);

  const importProducts =
  (event) => {

    const file =
      event.target.files[0];

    if (!file) return;

    const reader =
      new FileReader();

    reader.onload =
      (e) => {

        const data =
          new Uint8Array(
            e.target.result
          );

        const workbook =
          XLSX.read(
            data,
            { type: "array" }
          );

        const sheet =
          workbook.Sheets[
            workbook.SheetNames[0]
          ];

        const rows =
          XLSX.utils.sheet_to_json(
            sheet
          );

        const importedProducts =
          rows.map(
            (row) => ({

              id:
                Date.now() +
                Math.random(),

              name:
                row.ProductName || "",

              category:
                row.Category || "",

              sku:
                row.SKU || "",

              mrpPrice:
  "₹" + (row.MRP || 0),

              price:
                "₹" +
                (row.SellingPrice || 0),

              purchasePrice:
                row.PurchasePrice || 0,

              units:
                Number(
                  row.StockQty || 0
                ),

              gstRate:
                Number(
                  row.GSTRate || 0
                ),

              hsnCode:
                row.HSNCode || "",

              barcode:
                row.Barcode || "",

              unit:
                row.Unit || "",

              stock:
                row.Status ||
                "IN STOCK",

            }))

        setProducts(
          importedProducts
        );

        alert(
          importedProducts.length +
          " Products Imported"
        );

      };

    reader.readAsArrayBuffer(
      file
    );

};

  const exportProducts = () => {

  const exportData =
  products.map((item) => ({

    ProductName:
      item.name || "",

    Category:
      item.category || "",

    SKU:
      item.sku || "",

    MRP:
  Number(
    String(item.mrpPrice || 0)
      .replace("₹", "")
  ),

    SellingPrice:
      Number(
        String(item.price || 0)
          .replace("₹", "")
      ),

    PurchasePrice:
      item.purchasePrice || 0,

    StockQty:
      item.units || 0,

    GSTRate:
      item.gstRate || 0,

    HSNCode:
      item.hsnCode || "",

    Barcode:
      item.barcode || "",

    Unit:
      item.unit || "",

    Status:
      item.units > 0
        ? "IN STOCK"
        : "OUT OF STOCK",

  }));

  const worksheet =
    XLSX.utils.json_to_sheet(
      exportData
    );

  const workbook =
    XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "Products"
  );

  const excelBuffer =
    XLSX.write(
      workbook,
      {
        bookType: "xlsx",
        type: "array",
      }
    );

  const blob =
    new Blob(
      [excelBuffer],
      {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }
    );

  saveAs(
    blob,
    "Products.xlsx"
  );

};

  const navigate = useNavigate();

  const { 
    products,
    setEditingProduct,
    deleteProduct,
    setProducts,
    updateProduct,
   } = useContext(ProductContext);

   const [categoryFilter, setCategoryFilter] =
  useState("All");

   const inventoryValue = useMemo(() =>
  products.reduce(

    (sum, item) =>

      sum +

      (
        Number(
          item.price?.replace("₹", "")
        ) *

        Number(item.units || 0)
      ),

    0
  ), [products]);

  const filteredProducts = useMemo(() => products.filter((item) => {
  const categoryMatch =
    categoryFilter === "All" ||
    item.category === categoryFilter;

  const searchMatch =
    item.name
      ?.toLowerCase()
      .includes(deferredSearchTerm.toLowerCase()) ||
    item.sku
      ?.toLowerCase()
      .includes(deferredSearchTerm.toLowerCase()) ||
    item.botanical
      ?.toLowerCase()
      .includes(deferredSearchTerm.toLowerCase());

  return categoryMatch && searchMatch;
}), [products, categoryFilter, deferredSearchTerm]);

   const totalPages = Math.max(
  1,
  Math.ceil(
    filteredProducts.length /
    itemsPerPage
  )
);

const startIndex =
  (currentPage - 1) * itemsPerPage;

const paginatedProducts =
  filteredProducts.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const [showDrawer, setShowDrawer] =
  useState(false);

const [drawerProduct, setDrawerProduct] =
  useState(null);

  const lowStockCount = useMemo(() => products.filter(
  (item) => item.units > 0 && item.units <= 10
).length, [products]);

const outOfStockCount = useMemo(() => products.filter(
  (item) => item.units <= 0
).length, [products]);

const totalCategories = useMemo(() => new Set(
  products.map((item) => item.category)
).size, [products]);

  return (
    <div className="inventory-page">

      <div className="inventory-header">

        <div>
          <h1>Products Overview</h1>

          <p>
            Real-time garden stock and supply chain management.
          </p>
        </div>

        <button
  className="add-btn"
  onClick={exportProducts}
>

  Export Products

</button>

<button
  className="add-btn"
  onClick={() =>
    fileInputRef.current.click()
  }
>

  Import Products

</button>

<input
  type="file"
  accept=".xlsx,.xls"
  ref={fileInputRef}
  style={{
    display: "none"
  }}
  onChange={
    importProducts
  }
/>

        <button
          className="add-btn"
          onClick={() => navigate("/add-product")}
        >
          
          <FaPlus />
          Add New Product
        </button>
        

      </div>

      {/* CARDS */}

     <div className="inventory-cards">

  <div className="inventory-card blue-card">
    <div className="card-icon">📦</div>
    <div>
      <span>Total Products</span>
      <h2>{products.length}</h2>
    </div>
  </div>

  <div className="inventory-card green-card">
    <div className="card-icon">💰</div>
    <div>
      <span>Inventory Value</span>
      <h2>
        ₹{inventoryValue.toLocaleString()}
      </h2>
    </div>
  </div>

  <div className="inventory-card orange-card">
    <div className="card-icon">⚠️</div>
    <div>
      <span>Low Stock</span>
      <h2>{lowStockCount}</h2>
    </div>
  </div>

  <div className="inventory-card red-card">
    <div className="card-icon">❌</div>
    <div>
      <span>Out Of Stock</span>
      <h2>{outOfStockCount}</h2>
    </div>
  </div>

  <div className="inventory-card purple-card">
    <div className="card-icon">🏷️</div>
    <div>
      <span>Categories</span>
      <h2>{totalCategories}</h2>
    </div>
  </div>

  <div className="inventory-card indigo-card">
    <div className="card-icon">📊</div>
    <div>
      <span>Avg Product Value</span>
      <h2>
        ₹
        {products.length > 0
          ? Math.round(
              inventoryValue /
                products.length
            ).toLocaleString()
          : 0}
      </h2>
    </div>
  </div>

</div>

      

      {/* TABLE */}

      <div className="inventory-table-wrapper">

        <div className="inventory-filters">
          

          <div className="search-box">

            <FaSearch />

            <input
  type="text"
  placeholder="Search products..."
  value={searchTerm}
  onChange={(e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  }}
/>

          </div>

          <select
  className="category-filter"
  value={categoryFilter}
  onChange={(e) =>
    setCategoryFilter(e.target.value)
  }
>

  <option value="All">
    All Categories
  </option>

  {[
    ...new Set(
      products.map(
        item => item.category
      )
    )
  ].map((category, index) => (

    <option
      key={index}
      value={category}
    >
      {category}
    </option>

  ))}

</select>
           <select
  className="show-filter"
  value={itemsPerPage}
  onChange={(e) => {
    setItemsPerPage(
      Number(e.target.value)
    );
    setCurrentPage(1);
  }}
>
  <option value={10}>
  Show 10
</option>

<option value={25}>
  Show 25
</option>

<option value={50}>
  Show 50
</option>

<option value={100}>
  Show 100
</option>
</select>
          <select className="stock-filter">
            <option>Stock Status</option>
          </select>

          <div className="bulk-actions">

  <select
  className="bulk-filter"
  value={bulkAction}
    onChange={(e) =>
      setBulkAction(e.target.value)
    }
  >

    <option value="">
      Bulk Actions
    </option>

    <option value="delete">
      Delete Selected
    </option>

    

  </select>

  
  <button
  className="apply-btn"
  disabled={
    selectedProducts.length === 0
  }
  onClick={() => {

    if (
      bulkAction !== "delete"
    ) return;

    const confirmDelete =
      window.confirm(
        `Delete ${selectedProducts.length} products?`
      );

    if (!confirmDelete) return;

    selectedProducts.forEach(
      (id) => deleteProduct(id)
    );

    setSelectedProducts([]);
  }}
>
  Apply
</button>

</div>

        </div>

        <table className="inventory-table">

          <thead>

            <tr>
  <th>
    <input
      type="checkbox"
      onChange={(e) => {
        if (e.target.checked) {
          setSelectedProducts(
            paginatedProducts.map(
              product => product.id
            )
          );
        } else {
          setSelectedProducts([]);
        }
      }}
    />
  </th>
  <th>S.No</th>
  <th>Product Name</th>
  <th>Category</th>
  <th>SKU</th>
  <th>Stock Level</th>
  <th>MRP</th>
<th>Sale Price</th>
<th>GST</th>
<th>Actions</th>
</tr>

          </thead>

          <tbody>

            {paginatedProducts.map((item, index) => (

              <tr key={index}>

  <td>

    <input
      type="checkbox"

      checked={
        selectedProducts.includes(
          item.id
        )
      }

      onChange={(e) => {

        if (e.target.checked) {

          setSelectedProducts([
            ...selectedProducts,
            item.id
          ]);

        } else {

          setSelectedProducts(
            selectedProducts.filter(
              id => id !== item.id
            )
          );

        }

      }}
    />

  </td>    

         <td>
    {(currentPage - 1) * itemsPerPage + index + 1}
  </td>

                <td>

                  <div className="product-info">

                    <img
  src={
  item.images?.[0] ||
  item.image ||
  noImage
}
  alt="product"
/>

                    <span>{item.name}</span>

                  </div>

                </td>

                <td>{item.category}</td>

                <td>{item.sku}</td>

                <td>

                  <div className="stock-info">

                    <span
                      className={`stock-badge ${
  item.units > 0
    ? "in-stock"
    : "out-stock"
}`}
                    >
                      {item.units > 0
  ? "IN STOCK"
  : "OUT OF STOCK"}
                    </span>

                    <small>

  {item.units || 0} Units

</small>

                  </div>

                </td>

                

                <td>
  ₹{Number(
    String(item.mrpPrice || 0).replace("₹", "")
  ) || 0}
</td>

<td>
  ₹{Number(
    String(item.price || 0).replace("₹", "")
  ) || 0}
</td>

<td>
  {item.gstRate || 0}%
</td>

                <td>

                  <div className="action-icons">

                    <FaEdit
  onClick={() => {

    setEditingProduct(item);

    navigate("/add-product");

  }}
/>
                    <FaEye
  title="View Product"
  onClick={() => {

    setDrawerProduct(item);

    setShowDrawer(true);

  }}
/>
                    <FaBoxes
  title="Update Stock"
  onClick={() => {
    setSelectedProduct(item);
    setNewStockQty(item.units || 0);
    setShowStockModal(true);
  }}
/>
                    <FaTrash
  title="Delete Product"
  onClick={() => {

    const confirmDelete =
      window.confirm(
        "Delete this product?"
      );

    if (confirmDelete) {
      deleteProduct(item.id);
    }

  }}
/>

                    

                  </div>

                </td>

              </tr>

            ))}

          </tbody>

        </table>

        <div className="pagination">

  <button
    disabled={currentPage === 1}
    onClick={() =>
      setCurrentPage(currentPage - 1)
    }
  >
    Previous
  </button>

  <span>
    Page {currentPage} of {totalPages}
  </span>

  <button
    disabled={
      currentPage === totalPages
    }
    onClick={() =>
      setCurrentPage(currentPage + 1)
    }
  >
    Next
  </button>

</div>

      </div>


      {showStockModal && (
  <div className="modal-overlay">
    <div className="modal-content">

      <h3>Update Stock</h3>

      <input
        type="number"
        value={newStockQty}
        onChange={(e) =>
          setNewStockQty(e.target.value)
        }
      />

      <div style={{ marginTop: "15px" }}>

        <div className="stock-modal-actions">

  <button
    className="stock-save-btn"
    onClick={() => {

      updateProduct({
        ...selectedProduct,
        units: Number(newStockQty),
      });

      setShowStockModal(false);
    }}
  >
    Save
  </button>

  <button
    className="stock-cancel-btn"
    onClick={() =>
      setShowStockModal(false)
    }
  >
    Cancel
  </button>

</div>

      </div>

    </div>
  </div>
)}

{showDrawer && drawerProduct && (

  <div
    className="drawer-overlay"
    onClick={() =>
      setShowDrawer(false)
    }
  >

    <div
      className="product-drawer"
      onClick={(e) =>
        e.stopPropagation()
      }
    >

      <div className="drawer-header">

        <h2>
          Product Details
        </h2>

        <button
          onClick={() =>
            setShowDrawer(false)
          }
        >
          ✕
        </button>

      </div>

      <img
        src={
          drawerProduct.images?.[0] ||
          drawerProduct.image ||
          noImage
        }
        alt=""
        className="drawer-image"
      />

      <div className="drawer-body">

        <h3>
          {drawerProduct.name}
        </h3>

        <div className="product-status">
        🟢 In Stock
        </div>

        <p>
          <strong>SKU:</strong>
          {drawerProduct.sku}
        </p>

        <p>
          <strong>Category:</strong>
          {drawerProduct.category}
        </p>

        <p>
          <strong>Price:</strong>
          {drawerProduct.price}
        </p>

        <p>
          <strong>Stock:</strong>
          {drawerProduct.units} Units
        </p>

        <p>
          <strong>GST:</strong>
          {drawerProduct.gstRate}%
        </p>

        <p>
          <strong>HSN:</strong>
          {drawerProduct.hsnCode}
        </p>

      </div>

      <div className="drawer-actions">

  <button
    className="edit-btn"
    onClick={() => {
      setEditingProduct(drawerProduct);
      navigate("/add-product");
    }}
  >
    Edit Product
  </button>

  <button
    className="stock-btn"
    onClick={() => {
      setSelectedProduct(drawerProduct);
      setNewStockQty(
        drawerProduct.units || 0
      );
      setShowStockModal(true);
    }}
  >
    Update Stock
  </button>

  <button
    className="delete-btn"
    onClick={() => {

      const confirmDelete =
        window.confirm(
          "Delete this product?"
        );

      if(confirmDelete){
        deleteProduct(
          drawerProduct.id
        );
        setShowDrawer(false);
      }

    }}
  >
    Delete Product
  </button>

</div>

    </div>

  </div>

)}

    </div>
  );
}

export default Products;
